module.exports = __webpack_public_path__ + "static/media/S4N7-2.a99c52dd.svg";